// File: src/components/forms/SmartSelect/MobilePickerModal.tsx

import React, { useState, useEffect } from "react";
import styled from "styled-components";

interface Option {
  label: string;
  value: string;
}

interface Props {
  open: boolean;
  title: string;
  options: Option[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  onClose: () => void;
}

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
`;

const Modal = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.md};
  border-top-left-radius: ${({ theme }) => theme.radii.lg};
  border-top-right-radius: ${({ theme }) => theme.radii.lg};
  z-index: 1001;
`;

const Picker = styled.select`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.lg};
  font-size: 18px;
  border-radius: ${({ theme }) => theme.radii.md};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Button = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  font-size: 16px;
`;

export const MobilePickerModal: React.FC<Props> = ({
  open,
  title,
  options,
  selectedValue,
  onSelect,
  onClose,
}) => {
  const [tempValue, setTempValue] = useState(selectedValue || "");

  useEffect(() => {
    if (selectedValue) setTempValue(selectedValue);
  }, [selectedValue]);

  if (!open) return null;

  return (
    <>
      <Backdrop onClick={onClose} />
      <Modal>
        <Header>
          <Button onClick={onClose}>Cancel</Button>
          <strong>{title}</strong>
          <Button onClick={() => onSelect(tempValue)}>Done</Button>
        </Header>
        <Picker
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Picker>
      </Modal>
    </>
  );
};